module.exports = __webpack_public_path__ + "images/super-happy-filled99cc2f9a0284c2778f351f162ccb3abe.svg";